import { Box, Grid, GridProps, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import "./SectionCard.scss";
import { isString } from "lodash";
import LoadingSpinner from "./LoadingSpinner";

interface SectionCardProps extends GridProps {
  label?: string | ReactNode;
  rightItems?: ReactNode;
  children: ReactNode;
  isLoading?: any;
  /** When set and isLoading is true, shown instead of the default spinner */
  loadingContent?: ReactNode;
}

export default function SectionCard(props: SectionCardProps) {
  const { label, rightItems, children, isLoading, loadingContent, sx, ...rest } =
    props;
  return (
    <Grid
      container
      direction={"column"}
      className="section-card"
      wrap="nowrap"
      sx={[
        { display: "flex", flexDirection: "column", minHeight: 0 },
        ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
      ]}
      {...rest}
    >
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        className="section-card__title"
      >
        <Grid item sx={{ minWidth: 0 }}>
          {isString(label) ? <Typography>{label}</Typography> : <>{label}</>}
        </Grid>
        {rightItems && (
          <Grid item sx={{ flexShrink: 0 }}>
            {rightItems}
          </Grid>
        )}
      </Grid>
      {isLoading ? (
        <Box
          sx={{
            flex: "1 1 auto",
            minHeight: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: loadingContent ? "flex-start" : "center",
            px: loadingContent ? 1.5 : 0,
            pb: loadingContent ? 0.75 : 2,
            pt: 0,
          }}
        >
          {loadingContent ?? <LoadingSpinner size={30} showText={false} />}
        </Box>
      ) : (
        children
      )}
    </Grid>
  );
}
